import { render, staticRenderFns } from "./pigments.vue?vue&type=template&id=3f954d32&"
import script from "./pigments.vue?vue&type=script&lang=js&"
export * from "./pigments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports